module.exports = __webpack_public_path__ + "img/493.4217c813.png";